
import { IEdition } from "@/dtos/edition";
import { EditionInputDto } from "../../dtos/edition/EditionInputDto";
import { CreatePaymentDto } from "../../dtos/payment/CreatePaymentDto";
import { del, get, patch, post } from "../../utils/BaseService";
import { CreateTenantEditionDto } from "@/dtos/tenantEdition";

export async function getAllEdition(dispatch: any) {
   return await get(dispatch, '/edition/getAllEdition', null)
}

export async function getEditionById(dispatch: any, id: number) {
   return await get(dispatch, `/edition/getEditionById/${id}`, null); // Pass empty object as input
}
export async function updateEditionById(dispatch: any, param: number, details: IEdition) {
   return await patch(dispatch, `/edition/updateEdition`, details, param); // Pass empty object as input
}
export async function deleteEditionById(dispatch: any, param: number) {
   return await del(dispatch, `/edition/deleteEdition`, param); // Pass empty object as input
}

export async function createEdition(dispatch: any, input: EditionInputDto) {
   return await post(dispatch, '/edition/createEdition', input)
}

export async function createEditionPaymentAcc(dispatch: any, input: CreatePaymentDto) {
   return await post(dispatch, '/edition/createEditionPaymentAcc', input)
}
export async function getAllFeaturesByEditionId(dispatch: any, editionId: number) {
   return await get(dispatch, '/edition/getAllFeaturesByEditionId/' + editionId, null)
}
export async function createFreeSubscription(dispatch: any, input: CreateTenantEditionDto) {
   return await post(dispatch, '/tenantEdition/createFreeSubscription', input)
}